export const backdropShown = (state) => state.common.isBackdropShown;
export const videoUploadData = (state) => state.common.videoUploadData;
export const selectedFilters = (state) => state.common.filters;
